import { render, staticRenderFns } from "./ShipCanvasLayer.vue?vue&type=template&id=96b77376&scoped=true"
import script from "./ShipCanvasLayer.vue?vue&type=script&lang=js"
export * from "./ShipCanvasLayer.vue?vue&type=script&lang=js"
import style0 from "./ShipCanvasLayer.vue?vue&type=style&index=0&id=96b77376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b77376",
  null
  
)

export default component.exports